import { render, staticRenderFns } from "./EditBuildingAndRoomStructure.vue?vue&type=template&id=fd68b430&"
import script from "./EditBuildingAndRoomStructure.vue?vue&type=script&lang=js&"
export * from "./EditBuildingAndRoomStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports